import CrudAtendimento from '../views/Condutor/Index'
import Checklist from '../views/Condutor/Checklist'
import View from '../views/Condutor/View'

let routes = {
    path: '/solicitante',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/visualizar-solicitacao/:id?',
            name: 'Visualizar-solicitacao',
            component: View
        },
        {
            path: '/solicitante/index',
            name: 'list-solicitante',
            component: CrudAtendimento,
            meta: {
                pageTitle: 'Solicitações',
                breadcrumb: [
                    {
                        text: 'Solicitações',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/solicitante/checklist',
            name: 'solicitante-checklist',
            component: Checklist
        },
    ]
};


export default routes
